import { FORM_VALIDATOR_TYPES } from '../constants';
import { ICreatePostFormData } from '../interface/postModel';

export enum STATUS_OPTIONS {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export const initialFormData: ICreatePostFormData = {
  title: {
    value: '',
    error: null,
    isRequired: false,
    disable: false,
    validator: FORM_VALIDATOR_TYPES.TEXT,
  },
  description: {
    value: '',
    error: null,
    isRequired: false,
    disable: false,
    validator: FORM_VALIDATOR_TYPES.TEXT,
  },
  visibility: {
    value: [],
    error: null,
    isRequired: true,
    disable: false,
    validator: FORM_VALIDATOR_TYPES.ARRAY,
  },
  allowComments: {
    value: true,
    error: null,
    isRequired: false,
    disable: false,
    validator: FORM_VALIDATOR_TYPES.BOOLEAN,
  },
  status: {
    value: STATUS_OPTIONS.PUBLISHED,
    error: null,
    isRequired: true,
    disable: false,
    validator: FORM_VALIDATOR_TYPES.TEXT,
  },
  file: {
    value: null,
    error: null,
    isRequired: false,
    disable: false,
    validator: FORM_VALIDATOR_TYPES.FILE,
  },
  is_anonymous: {
    value: false,
    error: null,
    isRequired: false,
    disable: false,
    validator: FORM_VALIDATOR_TYPES.BOOLEAN,
  },
};
